// client/src/api/ApiAnalytics.js
import flex from './FlexFetch'

// Use 'insights' instead of 'analytics' to avoid ad blocker interference
// The 'insights' namespace is an alias that maps to the same analytics handlers
const analytics_endpoint = '/api/1.0/insights/'

async function getMetrics(startDate = null, endDate = null, limit = null) {
  const params = new URLSearchParams()
  if (startDate) params.append('start_date', startDate)
  if (endDate) params.append('end_date', endDate)
  if (limit) params.append('limit', limit)

  const queryString = params.toString()
  const url =
    analytics_endpoint + 'metrics' + (queryString ? '?' + queryString : '')

  const response = await flex.flexFetch(url, {
    credentials: 'include',
  })
  const json = await flex.handleResponse(response)
  return json.data
}

async function getEvents(
  limit = null,
  tag = null,
  userId = null,
  excludeTag = null,
  offset = null,
  excludeAdminUsers = null,
) {
  const params = new URLSearchParams()
  if (limit) params.append('limit', limit)
  if (tag) params.append('tag', tag)
  if (userId) params.append('user_id', userId)
  if (excludeTag) params.append('exclude_tag', excludeTag)
  if (offset) params.append('offset', offset)
  if (excludeAdminUsers !== null)
    params.append('exclude_admin_users', excludeAdminUsers)

  const queryString = params.toString()
  const url =
    analytics_endpoint + 'events' + (queryString ? '?' + queryString : '')

  const response = await flex.flexFetch(url, {
    credentials: 'include',
  })
  const json = await flex.handleResponse(response)
  return json.data
}

async function getHealth() {
  const url = analytics_endpoint + 'health'

  const response = await flex.flexFetch(url, {
    credentials: 'include',
  })
  const json = await flex.handleResponse(response)
  return json.data
}

async function getPerformance() {
  const url = analytics_endpoint + 'performance'

  const response = await flex.flexFetch(url, {
    credentials: 'include',
  })
  const json = await flex.handleResponse(response)
  return json.data
}

async function getDailyActiveUsersDetailed(startDate = null, endDate = null) {
  const params = new URLSearchParams()
  if (startDate) params.append('start_date', startDate)
  if (endDate) params.append('end_date', endDate)

  const queryString = params.toString()
  const url =
    analytics_endpoint +
    'dailyActiveUsersDetailed' +
    (queryString ? '?' + queryString : '')

  const response = await flex.flexFetch(url, {
    credentials: 'include',
  })
  const json = await flex.handleResponse(response)
  return json.data
}

async function getEventsByUser(startDate = null, endDate = null, limit = null) {
  const params = new URLSearchParams()
  if (startDate) params.append('start_date', startDate)
  if (endDate) params.append('end_date', endDate)
  if (limit) params.append('limit', limit)

  const queryString = params.toString()
  const url =
    analytics_endpoint + 'eventsByUser' + (queryString ? '?' + queryString : '')

  const response = await flex.flexFetch(url, {
    credentials: 'include',
  })
  const json = await flex.handleResponse(response)
  return json.data
}

async function getPrimaryMetrics(timeWindow = '7d') {
  const url = `${analytics_endpoint}primary-metrics?window=${timeWindow}`

  const response = await flex.flexFetch(url, {
    credentials: 'include',
  })
  const json = await flex.handleResponse(response)
  return json.data
}

const ApiAnalytics = {
  getMetrics,
  getEvents,
  getHealth,
  getPerformance,
  getDailyActiveUsersDetailed,
  getEventsByUser,
  getPrimaryMetrics,
}

export default ApiAnalytics
